<template>
        <div class="box">
           <inner-table id="innerViolation" ref="violationList" :listviewurl="'rap.punishmentManagement.list'" :can-edit="0" :can-delete="0" :link-prop-name="'studentId'" />
        </div>

</template>

<script>
export default {
    props: {
        vo: {}
    },
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        onInnerCellClick() {

        },
        onInnerTableListDataBeforeLoad($scope, qparams) {
            qparams.urlsearch = `studentId:${this.vo?.id}`
        }
    }
}
</script>

<style scoped>
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
   border:1px solid #999;
   padding-bottom: 1px;
}
</style>

